import {
  conversation,
  arrayOfConversations,
  arrayOfUserConversations,
  userConversation,
} from "~/schemas/schema.conversations.jsx";
import {
  FETCH_CONVERSATIONS_LOADING,
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATIONS_ERROR,
  FETCH_CONVERSATION_LOADING,
  FETCH_CONVERSATION_SUCCESS,
  FETCH_CONVERSATION_ERROR,
  ADD_CONVERSATION_LOADING,
  ADD_CONVERSATION_SUCCESS,
  ADD_CONVERSATION_ERROR,
  ADD_CONVERSATION_FROM_EVENT_STREAM,
  EDIT_CONVERSATION_FROM_EVENT_STREAM,
  FETCH_USER_CONVERSATIONS_LOADING,
  FETCH_USER_CONVERSATIONS_SUCCESS,
  FETCH_USER_CONVERSATIONS_ERROR,
  MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM,
  EDIT_USER_CONVERSATION_LOADING,
  EDIT_USER_CONVERSATION_SUCCESS,
  EDIT_USER_CONVERSATION_ERROR,
  EDIT_CONVERSATION_LOADING,
  EDIT_CONVERSATION_SUCCESS,
  EDIT_CONVERSATION_ERROR,
  LEAVE_CONVERSATION_LOADING,
  LEAVE_CONVERSATION_SUCCESS,
  LEAVE_CONVERSATION_ERROR,
  DELETE_CONVERSATION_USER_FROM_EVENT_STREAM,
  INVITE_USER_CONVERSATION_LOADING,
  INVITE_USER_CONVERSATION_SUCCESS,
  INVITE_USER_CONVERSATION_ERROR,
  ADD_CONVERSATION_ADMIN_LOADING,
  ADD_CONVERSATION_ADMIN_SUCCESS,
  ADD_CONVERSATION_ADMIN_ERROR,
  REMOVE_CONVERSATION_ADMIN_LOADING,
  REMOVE_CONVERSATION_ADMIN_SUCCESS,
  REMOVE_CONVERSATION_ADMIN_ERROR,
  REMOVE_CONVERSATION_PARTICIPANT_LOADING,
  REMOVE_CONVERSATION_PARTICIPANT_SUCCESS,
  REMOVE_CONVERSATION_PARTICIPANT_ERROR,
  DELETE_CONVERSATION_LOADING,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_ERROR,
  DELETE_CONVERSATION_FROM_EVENT_STREAM,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchConversations = () => {
  return {
    types: [FETCH_CONVERSATIONS_LOADING, FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations`,
      }),
    payload: {
      schema: arrayOfConversations,
    },
  };
};

export const fetchConversation = (id) => {
  return {
    types: [FETCH_CONVERSATION_LOADING, FETCH_CONVERSATION_SUCCESS, FETCH_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}`,
      }),
    payload: {
      objectType: "Conversation",
      id,
      schema: {
        single: conversation,
      },
    },
  };
};

export const fetchTypeConversation = (id, type) => {
  return {
    types: [FETCH_CONVERSATION_LOADING, FETCH_CONVERSATION_SUCCESS, FETCH_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${type}/${id}`,
      }),
    payload: {
      id,
      conversationType: type,
      schema: {
        single: conversation,
      },
    },
  };
};

export const addConversation = (attributes) => {
  return {
    types: [ADD_CONVERSATION_LOADING, ADD_CONVERSATION_SUCCESS, ADD_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: conversation,
      },
    },
  };
};

export const editConversation = (id, attributes) => {
  return {
    types: [EDIT_CONVERSATION_LOADING, EDIT_CONVERSATION_SUCCESS, EDIT_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      id,
      attributes,
      schema: {
        single: conversation,
      },
    },
  };
};

export const deleteConversation = (id) => {
  return {
    types: [DELETE_CONVERSATION_LOADING, DELETE_CONVERSATION_SUCCESS, DELETE_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}`,
        method: `delete`,
      }),
    payload: {
      id,
    },
  };
};

export const deleteConversationFromEventStream = (id) => {
  return {
    type: DELETE_CONVERSATION_FROM_EVENT_STREAM,
    id,
  };
};

export const renameGroupConversation = (id, attributes) => {
  return {
    types: [EDIT_CONVERSATION_LOADING, EDIT_CONVERSATION_SUCCESS, EDIT_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}/rename`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      id,
      attributes,
      schema: {
        single: conversation,
      },
    },
  };
};

export const leaveConversation = (id) => {
  return {
    types: [LEAVE_CONVERSATION_LOADING, LEAVE_CONVERSATION_SUCCESS, LEAVE_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}/leave`,
        method: `put`,
      }),
    payload: {
      id,
    },
  };
};

export const addConversationFromEventStream = (data) => {
  return {
    type: ADD_CONVERSATION_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: conversation,
    },
  };
};

export const editConversationFromEventStream = (data) => {
  return {
    type: EDIT_CONVERSATION_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: conversation,
    },
  };
};

export const fetchUserConversations = () => {
  return {
    types: [FETCH_USER_CONVERSATIONS_LOADING, FETCH_USER_CONVERSATIONS_SUCCESS, FETCH_USER_CONVERSATIONS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/user-conversations`,
      }),
    payload: {
      schema: arrayOfUserConversations,
    },
  };
};

export const manageConversationUser = (data) => {
  return {
    type: MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: userConversation,
    },
  };
};

export const deleteConversationUser = (data) => {
  return {
    type: DELETE_CONVERSATION_USER_FROM_EVENT_STREAM,
    response: {
      single: data,
    },
    schema: {
      single: userConversation,
    },
  };
};

export const editUserConversation = (conversationId, attributes) => {
  return {
    types: [EDIT_USER_CONVERSATION_LOADING, EDIT_USER_CONVERSATION_SUCCESS, EDIT_USER_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/user-conversations/${conversationId}`,
        method: "PUT",
        body: attributes,
      }),
    payload: {
      conversationId,
      attributes,
      schema: {
        single: userConversation,
      },
    },
  };
};

export const inviteUserConversation = (conversationId, userIds) => {
  return {
    types: [INVITE_USER_CONVERSATION_LOADING, INVITE_USER_CONVERSATION_SUCCESS, INVITE_USER_CONVERSATION_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${conversationId}/invite`,
        method: "POST",
        body: {
          user_ids: userIds,
        },
      }),
    payload: {
      conversationId,
      userIds,
      schema: {
        single: conversation,
      },
    },
  };
};

export const addConversationAdmin = (id, userId) => {
  return {
    types: [ADD_CONVERSATION_ADMIN_LOADING, ADD_CONVERSATION_ADMIN_SUCCESS, ADD_CONVERSATION_ADMIN_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}/admins/${userId}`,
        method: `post`,
      }),
    payload: {
      id,
      userId,
      schema: {
        single: conversation,
      },
    },
  };
};

export const removeConversationAdmin = (id, userId) => {
  return {
    types: [REMOVE_CONVERSATION_ADMIN_LOADING, REMOVE_CONVERSATION_ADMIN_SUCCESS, REMOVE_CONVERSATION_ADMIN_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}/admins/${userId}`,
        method: `delete`,
      }),
    payload: {
      id,
      userId,
      schema: {
        single: conversation,
      },
    },
  };
};

export const removeConversationParticipant = (id, userId) => {
  return {
    types: [
      REMOVE_CONVERSATION_PARTICIPANT_LOADING,
      REMOVE_CONVERSATION_PARTICIPANT_SUCCESS,
      REMOVE_CONVERSATION_PARTICIPANT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/conversations/${id}/remove/${userId}`,
        method: `delete`,
      }),
    payload: {
      id,
      userId,
      schema: {
        single: conversation,
      },
    },
  };
};
